import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LogisticIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ActualDateChange, PlannedDateToken, RequestDateToken, ValidationItem, ValidationSummary, ActualDateToken, PartialDelivery, GenFileUploads, SubSalesOrder } from '../../../shared/misc-classes';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { SAPFetchResultDialog, SAPTableColumn, SAPFetchResultData } from '../../../dialogs/sap-fetch-result-dialog/sap-fetch-result-dialog';
import { ConfigurationService } from '../../../shared/configuration.service';

@Component({
  selector: 'logistic',
  templateUrl: './logistic.component.html',
  styleUrls: ['./logistic.component.css']
})
export class LogisticComponent implements OnInit, OnChanges {

  @Input() soLockObtained: boolean;
  @Input() logisticObj: LogisticIP;
  @Input() loadCounter: SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;
  Hvr: any = {};

  public _SSOStatus = SSOStatus;
  _subsaleOrder: SubSalesOrder;
  userLogged_temp: string;
  isUserImpEnabled: boolean = false;

  modifyReqDate: boolean = false;
  modifyPlanDate: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  constructor(public _dataService: DataService, public dialog: MatDialog, private _configurationService: ConfigurationService) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.userLogged_temp = this._dataService.userId;
    if (this.userLogged_temp == this._configurationService.getSingleEmail('LOGISTICS_ADMIN')) {
      this.isUserImpEnabled = true;
    }
  }

  ngOnChanges() {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.logisticObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.logisticObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasLogisticsEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    this.logisticObj.packListFiles.headerStr = "Packing List Files" + " - " + this.logisticObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" + this.logisticObj.parentSubSORef.subOrderNoId;
    this.logisticObj.packListFiles.disableUpload = false;
    this.logisticObj.photoUploadFiles.headerStr = "Photo Upload Files" + " - " + this.logisticObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" + this.logisticObj.parentSubSORef.subOrderNoId;
    this.logisticObj.photoUploadFiles.disableUpload = false;

    this.logisticObj.dcUploadFiles.headerStr = "DC Upload Files" + " - " + this.logisticObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" + this.logisticObj.parentSubSORef.subOrderNoId;
    this.logisticObj.dcUploadFiles.disableUpload = false;
    this.logisticObj.invoiceUploadFiles.headerStr = "Invoice Files" + " - " + this.logisticObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" + this.logisticObj.parentSubSORef.subOrderNoId;
    this.logisticObj.invoiceUploadFiles.disableUpload = this.disableForm;
    // this.logisticObj.finaldespatchdocuments.headerStr = "Final Despatch Documents";
    // this.logisticObj.finaldespatchdocuments.disableUpload = false;


    this.logisticObj.ewayBillFiles.headerStr = "E-Way Bill Files" + " - " + this.logisticObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" + this.logisticObj.parentSubSORef.subOrderNoId;
    this.logisticObj.ewayBillFiles.disableUpload = false;
    // this.logisticObj.lrCopyFiles.headerStr = "LR Copy Files";
    // this.logisticObj.lrCopyFiles.disableUpload = this.disableForm;
    this.logisticObj.invoiceUploadFiles.headerStr = "Invoice Files" + " - " + this.logisticObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" + this.logisticObj.parentSubSORef.subOrderNoId;
    this.logisticObj.invoiceUploadFiles.disableUpload = false;

    // this.logisticObj.ewayBillFiles.headerStr = "E-Way Bill Files";
    // this.logisticObj.ewayBillFiles.disableUpload = false;
    // this.logisticObj.lrCopyFiles.headerStr = "LR Copy Files";
    // this.logisticObj.lrCopyFiles.disableUpload = false;
  }

  saveSso(_submitToNextSection: boolean, ssoSubmitTo: SSOStatus = SSOStatus.Not_Started) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data),
        null,
        ssoSubmitTo
      ));
    }
  }

  BringUndispatchedBack(_submitToNextSection: boolean, ssoSubmitTo: SSOStatus = SSOStatus.Not_Started) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data),
        null,
        ssoSubmitTo
      ));
    }
  }

  deleteSSo(_deleteSO: boolean) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }

  }
  showSsoValidation() {
    let _errorMessage: string = this.logisticObj.dispatchErrorMessage;
    let _validList: Array<ValidationItem> = [];
    _validList.push(new ValidationItem("Dispatch Panel Quantity Validation", this.logisticObj.readyForDispacth, _errorMessage));


    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);

    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }


  addNewDispatch() {
    this.logisticObj.addPartialDelivery();
  }

  removeDispatch(_index: number) {
    this.logisticObj.removePartialDelivery(_index);
  }

  requestDateChangeHandler(_reqDateHeader: string, _reqTokenKeyName: string, _plndReqDate: Date, _reqDateChanged: Date): void {
    let _plndDateChangeObj: ActualDateChange = new ActualDateChange("Why is the request date changed ?", _reqDateHeader + "(existing)",
      _plndReqDate, _reqDateHeader + "(edited)", _reqDateChanged, this.logisticObj[_reqTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.logisticObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.logisticObj[_reqTokenKeyName] =
          new RequestDateToken(new Date(_reqDateChanged.getTime()), true, null, _plndDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.logisticObj[_reqTokenKeyName].requestDate = _plndReqDate;
      }
    });
  }

  actualDateChangeHandler_2(_actDateHeader: string, _actDate: Date, _actDateChanged: Date, _actTokenKeyName: string,
    _plndDateHeader: string, _plndDate: Date, _pDelivery: PartialDelivery): void {
    let _actDateChangeObj: ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader,
      _actDateChanged, _pDelivery[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate: Date = _pDelivery[_actTokenKeyName].actualDate;
    _pDelivery[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        _pDelivery[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if (_actDateChangeObj.actualDate != null) {
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        _pDelivery[_actTokenKeyName] =
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments, this._dataService.userId);
      }
      else {
        _pDelivery[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader: string, _plndTokenKeyName: string, _plndDate: Date, _plndDateChanged: Date): void {
    let _plndDateChangeObj: ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)",
      _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.logisticObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.logisticObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.logisticObj[_plndTokenKeyName] =
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.logisticObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  packListUploadClick(_evn: any) {
    _evn.stopPropagation();
    this.showFileManager.emit(this.logisticObj.packListFiles);
  }
  photoUploadClick(_evn: any) {
    _evn.stopPropagation();
    this.showFileManager.emit(this.logisticObj.photoUploadFiles);
  }
  dcUploadClick(_evn: any) {
    _evn.stopPropagation();
    this.showFileManager.emit(this.logisticObj.dcUploadFiles);
  }
  invoiceUploadClick(_evn: any) {
    _evn.stopPropagation();
    this.showFileManager.emit(this.logisticObj.invoiceUploadFiles);
  }
  // finaldespatchUploadClick(_evn:any){
  //   _evn.stopPropagation();
  //   this.showFileManager.emit(this.logisticObj.finaldespatchdocuments);
  // }

  ewayBillUploadClick(_evn: any) {
    _evn.stopPropagation();
    this.showFileManager.emit(this.logisticObj.ewayBillFiles);
  }
  lrCopyUploadClick(_evn: any) {
    _evn.stopPropagation();
    this.showFileManager.emit(this.logisticObj.lrCopyFiles);
  }

  private formatSAPDateForPopup(value: any): string {
    if (!value) {
      return '';
    }

    const dt = this.parseSAPDate(value);
    if (!dt) {
      return '';
    }

    return dt.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  fetchDispatchFromSAP() {
    if (this.disableForm) {
      return;
    }

    const _soNo = this.logisticObj.parentSORef &&
      this.logisticObj.parentSORef.marketingIP
      ? this.logisticObj.parentSORef.marketingIP.salesOrderNo
      : null;

    const _subSoNo = this.logisticObj.parentSubSORef && this.logisticObj.parentSubSORef.pmTechSubSalesOrder
      ? this.logisticObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo : null;

    if (!_soNo) {
      this._dataService.openSnackbar('Sales Order not available', 'Close');
      return;
    }

    const _plan = this.logisticObj.parentSubSORef && this.logisticObj.parentSubSORef.planningIP
      ? this.logisticObj.parentSubSORef.planningIP : null;

    const _start = _plan && _plan.sapStartRange ? _plan.sapStartRange.toString().trim() : '';
    const _end = _plan && _plan.sapEndRange ? _plan.sapEndRange.toString().trim() : '';
    const _serialDataCount = _plan && _plan.serialData ? _plan.serialData.length : 0;

    // Validation: Check if Planning has valid input
    if (!_start && !_end ) {
      this._dataService.openSnackbar(
        'Enter Start Range to fetch SAP data',
        'Close'
      );
      return;
    }

    let _msg: any = { SO: _soNo };
    if (_start && _end) {
      _msg.Item_Range_GE = _start;
      _msg.Item_Range_LE = _end;
    } else if (_start) {
      _msg.LINE_NO = _start;
    }

    // Open modal with loading state
    // Note: Item No column removed - duplicates are dedup'd before display
    const columns: SAPTableColumn[] = [
      { key: 'dispQty', label: 'Dispatch Qty', width: '150px' },
      { key: 'actDate', label: 'Invoice Actual Date', width: '150px', formatter: (value) => this.formatSAPDateForPopup(value) },
      { key: 'dispActDate', label: 'Dispatched Actual Date (MDS)', width: '150px', formatter: (value) => this.formatSAPDateForPopup(value) }
    ];

    const dialogData: SAPFetchResultData = {
      title: 'Dispatch Details',
      isLoading: true,
      loadingMessage: 'Fetching dispatch details from SAP, please wait...',
      columns: columns,
      rows: [],
      totalRecords: 0
    };

    const dialogRef = this.dialog.open(
      SAPFetchResultDialog,
      {
        minWidth: '350px',
        panelClass: 'sap-modal-dialog',
        data: dialogData
      }
    );

    this._dataService.fetchDispatchSAPData(_soNo, _subSoNo, _msg).subscribe((resp: any) => {
      if (resp && resp.status === 'OK') {
        const _rows = this.extractDispatchRows(resp);

        // Deduplicate rows based on Item No BEFORE displaying in modal
        const _dedupMap: any = {};
        (_rows || []).forEach((_row: any) => {
          const _itemNo = (_row.ITEM_NO || _row.itemNo || _row.itemno || '').toString();
          if (_itemNo && !_dedupMap[_itemNo]) {
            _dedupMap[_itemNo] = _row;
          }
        });

        const _dedupRows = Object.values(_dedupMap);
        // Display deduplicated data in modal (Item No column removed)
        dialogRef.componentInstance.refreshData(
          _dedupRows,
          _dedupRows.length
        );

        // When dialog closes, bind the already-deduplicated data
        dialogRef.afterClosed().subscribe(() => {
          const _newDeliveries: Array<PartialDelivery> = [];
          _dedupRows.forEach((_row: any) => {
            // Existing mappings retained + SAP response mappings added
            const _qtyVal = parseInt(
              (_row.dispQty || '0').toString(),
              10
            );

            const _qty = Number.isNaN(_qtyVal) ? 0 : _qtyVal;
            const _invoiceActualDate = this.parseSAPDate(_row.actDate);
            const _dispatchedActualDate = this.parseSAPDate(_row.dispActDate);

            const _actualDateToken = new ActualDateToken(
              _invoiceActualDate,
              false,
              null,
              '',
              ''
            );

            if (_invoiceActualDate) {
              _actualDateToken.addNotes =
                'Fetched from SAP Dispatch data - Invoice Actual Date';

              _actualDateToken.userOveridden =
                this._dataService.userId;

              _actualDateToken.isOveridden = true;
            }

            const _partialDelivery = new PartialDelivery(
              _qty,
              _actualDateToken,
              _dispatchedActualDate
            );
            _newDeliveries.push(_partialDelivery);
          });

          if (_newDeliveries.length === 0) {
            _newDeliveries.push(new PartialDelivery(0, new ActualDateToken(null, false, null, '', ''), null));
          }
          this.logisticObj.partialDeliveries = _newDeliveries;
          this._dataService.openSnackbar('Dispatch details loaded from SAP', 'Close');
        });
      } else {
        dialogRef.componentInstance.showError();

        this._dataService.openSnackbar(
          resp && resp.message
            ? resp.message
            : 'Unable to fetch SAP dispatch data',
          'Close'
        );
      }
    }, (_err: HttpErrorResponse) => {
      dialogRef.componentInstance.showError();
      this._dataService.openSnackbar(
        'Error while fetching dispatch data',
        'Close'
      );

    });
  }

  private extractDispatchRows(resp: any): Array<any> {
    if (!resp) {
      return [];
    }

    if (Array.isArray(resp.SUB_ROOT)) {
      return resp.SUB_ROOT;
    }

    const _data = resp && resp.data ? resp.data.data : null;

    if (_data && Array.isArray(_data.SUB_ROOT)) {
      return _data.SUB_ROOT;
    }

    if (resp.data && Array.isArray(resp.data.SUB_ROOT)) {
      return resp.data.SUB_ROOT;
    }

    if (Array.isArray(_data)) {
      return _data;
    }

    if (_data && _data.SUB_ROOT) {
      return Array.isArray(_data.SUB_ROOT)
        ? _data.SUB_ROOT
        : [_data.SUB_ROOT];
    }
    return [];
  }

  private parseSAPDate(_value: any): Date {
    if (!_value) {
      return null;
    }
    const _raw = _value.toString();
    if (_raw.length === 8 && /^\d{8}$/.test(_raw)) {
      const _formatted = _raw.substring(0, 4) + '-' + _raw.substring(4, 6) + '-' + _raw.substring(6, 8);
      const _ts = Date.parse(_formatted);
      if (!Number.isNaN(_ts)) {
        return new Date(_ts);
      }
    }
    const _fallback = new Date(_raw);
    return Number.isNaN(_fallback.getTime()) ? null : _fallback;
  }
}
